export default "/images/vendor/flag-icon-css/flags/1x1/bs.svg?a9ddb124f725485b9445976c1db059b0";